export { default } from './request-equipment-service-footer';
